import api from "./api";
import type { TreatmentPlan } from "./types";

// Re-export types
export type { TreatmentPlan };

// GET /api/TreatmentPlan/patient/{patientId}
export const fetchTreatmentPlanByPatient = async (
  patientId: number
): Promise<TreatmentPlan[]> => {
  const resp = await api.get<TreatmentPlan[]>(
    `/TreatmentPlan/patient/${patientId}`
  );
  return resp.data;
};